import { notification, Switch } from "antd";

import {
  updateUserManager,
  updateUserOfferExtraTrip,
} from "../../../services/userAPI";

export interface Props {
  userId: number | null | undefined;
  disabled?: boolean;
  switchValue: boolean;
  isOfferExtraTrip?: boolean | false;
  setIgnoreFetch: any;
}

const UserManagerSwitch = ({
  userId,
  disabled = false,
  switchValue,
  setIgnoreFetch,
  isOfferExtraTrip,
}: Props) => {
  const onChange = async (value: boolean) => {
    try {
      if (!isOfferExtraTrip) {
        await updateUserManager(userId, value).then(() => {
          notification.success({
            message: "Se actualizo el tipo de usuario exitosamente",
            placement: "bottom",
            key: "global",
          });
        });
      } else {
        await updateUserOfferExtraTrip(userId, value).then(() => {
          notification.success({
            message: "Se actualizo la notificacion extra al usuario",
            placement: "bottom",
            key: "global",
          });
        });
      }
      setIgnoreFetch(false);
    } catch (error) {
      notification.error({
        message: `Ha ocurrido un error al cambiar el tipo de usuario, intentelo más tarde.`,
        placement: "bottom",
        key: "global",
      });
    }
  };

  return (
    <Switch checked={switchValue} onChange={onChange} disabled={disabled} />
  );
};

export default UserManagerSwitch;
